import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminProductsPage.css";

const AdminProductsPage = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");


  const fetchProducts = async () => {
    try {
      setLoading(true);
      const currentToken = localStorage.getItem("admin_token");

      if (!currentToken) {
        setError("Session expired or missing token. Please log in again.");
        setLoading(false);
        return;
      }

      const response = await fetch(
        "https://rbuymart.rbhardwaj.com/server/api/admin/get-all-products.php",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${currentToken}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok && data.status === "success") {
        setProducts(data.products || []);
      } else {
        setError(data.message || "Failed to fetch inventory dataset.");
      }
    } catch (err) {
      setError("Network communication breakdown. Could not reach server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);


  const handleDeleteProduct = async (id) => {
    if (
      !window.confirm(
        "Are you absolutely sure you want to purge this product record?"
      )
    )
      return;

    const currentToken = localStorage.getItem("admin_token");
    if (!currentToken) {
      alert("Session missing. Please log in again.");
      return;
    }

    try {
      const response = await fetch(
        "https://rbuymart.rbhardwaj.com/server/api/admin/delete_product.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${currentToken}`,
          },
          body: JSON.stringify({ id }),
        }
      );
      const data = await response.json();

      if (data.status === "success") {
        alert("Product successfully removed!");
        setProducts((prev) => prev.filter((p) => p.id !== id));
      } else {
        alert(data.message || "Delete operation failed.");
      }
    } catch (err) {
      alert("Network failure during delete operation.");
    }
  };

  const filteredProducts = products.filter(
    (product) =>
      product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.sku &&
        product.sku.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading)
    return <div className="admin-loader">Loading products dataset...</div>;

  if (error) return <div className="admin-error-banner">{error}</div>;

  return (
    <div className="admin-products-container">
  

   <div class="admin-header-tap">
     
          <h3>Product List</h3>
        <div className="flex-div">
<div className="search-input">
  <i class="material-icons">&#xe8b6;</i>
   <input
            type="search"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            
          />
</div>
       


          <button onClick={() => window.print()} className="btn-print">
            <i className="material-icons">&#xe8ad;</i> 
          </button>
          <button
            className="btn-add"
            onClick={() => navigate("/admin/productlist/addproduct")}
          >
            <i className="material-icons">&#xe148;</i> Add
          </button>

        </div>
        </div>


      <div className="table-div">
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Slug</th>
              <th>Short Description</th>
              <th>Category</th>
              <th>Brand</th>
              <th>SKU</th>
              <th>Selling Price</th>
              <th>MRP / Compare</th>
              <th>Weight</th>
              <th>GST (%)</th>
              <th>Stock</th>
              <th>Status</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.length === 0 ? (
              <tr>
                <td
                  colSpan="15"
                  style={{
                    textAlign: "center",
                    padding: "25px",
                    color: "#718096",
                  }}
                >
                  No live product records found matching your search term.
                </td>
              </tr>
            ) : (
              filteredProducts.map((product) => (
                <tr key={product.id}>
                  {/* 1. Primary Image Mapping */}
                  <td>
                    <img
                      src={
                        product.primary_image
                          ? `https://rbuymart.rbhardwaj.com/server/${product.primary_image}`
                          : "https://via.placeholder.com/50"
                      }
                      alt={product.name}
                      className="admin-prod-thumb"
                    />
                  </td>

                  {/* 2. Product Details */}
                  <td>{product.name}</td>
                  <td>{product.slug}</td>
                  <td>{product.short_description || "N/A"}</td>
                  <td>{product.category_name || "Uncategorized"}</td>
                  <td>{product.brand_name || "No Brand"}</td>
                  <td>{product.sku || "N/A"}</td>

                  <td>₹{parseFloat(product.price || 0).toLocaleString("en-IN")}</td>
                  <td>
                    ₹
                    {parseFloat(product.compare_at_price || 0).toLocaleString(
                      "en-IN"
                    )}
                  </td>
                  <td>{product.weight || 0} kg</td>
                  <td>{product.gst_percent}%</td>
                  <td>{product.stock}</td>
                  <td>
                    <span className={`status-badge ${product.status}`}>
                      {product.status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() =>
                        navigate(`/admin/editproduct/${product.id}`)
                      }
                    >
                      <i className="material-icons">&#xe3c9;</i> Edit
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn-delete"
                      onClick={() => handleDeleteProduct(product.id)}
                    >
                      <i className="material-icons">&#xe872;</i> Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminProductsPage;